import { useContext } from "react";
import { useKeycloak } from "../../../auth";
import { getTokenFromStorage } from "../../config/storageConfig";
import { AppConfig } from "../../context/context";
import ManageUsers from "@kdda/user-management-fragment" 


// need to pass getTokenFromStorage to user fragment
const UsersPage = () => {
  const { config, userProfile, setUserProfile } = useContext(AppConfig);

  return (
    <ManageUsers
      config={config}
      profile={userProfile}
      setUserProfile ={setUserProfile}
      getTokenFromStorage={getTokenFromStorage}
      getKeycloak= {useKeycloak}
    />
  );
};

export default UsersPage;
